import React, { useRef, useState } from "react";
import { colors, fonts, mediaQueriesNumbers, useMediaQuery, frames, glyphs, css } from "../../Styles";
import { NewInput, Button, NewInputHandles, NewModal, MainContentPaddingTypes } from "..";
import { ButtonTypes } from "../../Definitions";
import { useTranslation } from "react-i18next";
import { useUser } from "../../Services"

interface forgotPwdProps {
  ifSucces: () => void
  onGoBack: () => void
}

export default function ForgotPasswordModal({ifSucces, onGoBack}:forgotPwdProps) {
  const {t} = useTranslation()
  const {createUserResetToken} = useUser();
  const inputRef = useRef<NewInputHandles>(null); 
  const [message, setMessage] = useState<string|null>(null)
  const mobile = useMediaQuery(`(max-width: ${mediaQueriesNumbers.mobileMax}px)`);  

  // Use "Enter" to submit
  onkeydown = (event) => {
    if (event.code === "Enter") {
      ForgotPasswordAction()
    }
  }

  const ForgotPasswordAction = () => {
    const Username = inputRef.current?.value;
    if (!Username) {
      inputRef.current?.setError();
      setMessage(t("loginFlow.forgotPassword.usernameRequired", {defaultValue: "user Name Required"}))
    } else {
      createUserResetToken(Username.toString()).then(success => {
        if (success) 
          ifSucces()
        else setMessage(t("loginFlow.forgotPassword.noUsernameFound", {defaultValue: "username does not excist"}))
      })
    }
    setTimeout(() => {
      setMessage(null);
    }, 2000);
  };

  return (
      <frames.DecorBg>      
        <NewModal 
          modalState
          header={t("loginFlow.login.forgotPassword", {defaultValue: "Forgot Password"})} 
          overrides={{ 
            mainContentPadding: MainContentPaddingTypes.secondary,
            overlayColor: colors.blackPrimary+"99"
          }}
          predefinedButtons={{
            onGoBack: onGoBack 
          }}
          mainContent={            
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "20px", width: mobile? "280px" : "fit-content"}}>
              {/* If no email, contact support. */}
              <p style={{ ...fonts.paragraph, ...fonts.textShadow, ...fonts.fontSize3, color: colors.greyLightTertiary, textAlign: "center", whiteSpace: 'pre-wrap', maxWidth: "280px" }}>
                {t("loginFlow.forgotPassword.text", {defaultValue: "Text not found"})}
              </p>
              {/* Don't close the window. */}
              <p style={{ ...fonts.paragraph, ...fonts.textShadow, ...fonts.fontSize3, color: colors.greyLightTertiary, textAlign: "center", whiteSpace: 'pre-wrap', maxWidth: "280px" }}>
                {t("loginFlow.forgotPassword.text2", {defaultValue: "Text not found"})}
              </p>
              <NewInput ref={inputRef}
                placeholder={t("user.userName", {defaultValue: "User Name"})}
                startEnhancer={glyphs.User({})}
                valueOverrides={{
                  valueType: "text"
                }}
              />
              {/* Reset password button */}
              <Button content={t("loginFlow.login.resetPassword", {defaultValue: "Reset Password"})} onClick={ForgotPasswordAction}
                buttonType={ButtonTypes.primaryButton}
                overrides={{
                  baseButton: {...css.button_FitContent},
                }}
              />
              {/* Contact Support */}
              <div style={{marginTop: "10px", display: "flex", alignItems: "center", flexDirection: "column"}}>
                <p style={{ ...fonts.paragraph, ...fonts.fontSize4, color: colors.greyLightTertiary, textAlign: "center", marginBottom: "5px" }}>{`${t("loginFlow.forgotPassword.noEmail", {defaultValue: "No email assigned"})}?`}</p>
                <Button
                  content={t("loginFlow.forgotPassword.contactSupport", {defaultValue: "Contact Support"})}
                  onClick={() => window.location.href = 'mailto:support@agrisys.dk'}
                  buttonType={ButtonTypes.textButton}
                  overrides={{
                    baseButton: {...css.button_TextUnderline}
                  }}
                />
                <p style={{ ...fonts.paragraph, ...fonts.fontSize4, color: colors.greyLightTertiary, textAlign: "center", marginTop: "2px" }}>support@agrisys.dk</p>
              </div>
              {message && <p style={{ ...fonts.header, ...fonts.textShadow, ...fonts.fontSize4, color: colors.greyLightTertiary, position: "absolute", top: mobile ? "370px" : "378px" }}>{message}</p>}
            </div>
          }
        />
      </frames.DecorBg>
    )
}